import styles from "./LogoutModal.module.css";

const LogoutModal = ({ onConfirm, onCancel }) => {
  return (
    <div className={styles.overlay} onClick={onCancel}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.icon}>👋</div>
        <h3>Logout from Chatify?</h3>
        <p>You will be signed out of your account. You can sign back in anytime.</p>
        <div className={styles.actions}>
          <button className={styles.cancelBtn} onClick={onCancel}>Cancel</button>
          <button className={styles.logoutBtn} onClick={onConfirm}>Yes, Logout</button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
